module.exports = __webpack_public_path__ + "static/media/mt3.3a252d34.jpg";